import axios from 'axios'
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'StaClient',
  data () {
    return {
      db_address: process.env.VUE_APP_FROST_STA_ADDRESS,
      beluga_proxy: process.env.VUE_APP_BELUGA_PROXY_URL
    }
  },
  computed: {
    ...mapState(['platforms', 'selectedAsyncDataset']),
    ...mapGetters(['asyncDatasetExists', 'asyncDatasetSelected'])
  },
  mounted () {
    // Subscribe to store mutations
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type === 'select_async_dataset') {
        const platformId = mutation.payload.platform_id
        if (platformId in this.platforms &&
          !(mutation.payload.ts_start in this.platforms[platformId].async_datasets)) {
          this.downloadDataset(mutation.payload)
        } else {
          console.log('sta client: asynchronous dataset ' + platformId + ' / ' + mutation.payload.ts_start + ' already downloaded')
        }
      }
    })
  },
  beforeDestroy () {
    // Unsubscribe from mutation
    this.unsubscribe()
  },
  methods: {
    downloadDataset: function (dataset) {
      console.log(dataset)
      console.log('sta client: downloading asynchronous dataset ' + dataset.platform_id + ' / ' + dataset.ts_start)
      // Prepare server request
      const staUrl = dataset.url_sta
      const sensors = ('sensors' in dataset) ? dataset.sensors : []
      const startTs = moment.utc(new Date(dataset.ts_start * 1000)).format('YYYY-MM-DDTHH:mm:ss[Z]')
      const endTs = moment.utc(new Date(dataset.ts_end * 1000)).format('YYYY-MM-DDTHH:mm:ss[Z]')
      let requestUrl = 'Things?$filter=properties/platform_id%20eq%20\'' + dataset.sta_id + '\'' +
        '%20and%20Datastreams/properties/profiling%20eq%20true'
      if (sensors.length >= 1) {
        requestUrl += '%20and%20(Datastreams/Sensor/properties/serial_number%20eq%20\'' + sensors[0] + '\''
        for (let i = 1; i < sensors.length; i++) {
          requestUrl += '%20or%20Datastreams/Sensor/properties/serial_number%20eq%20\'' + sensors[i] + '\''
        }
        requestUrl += ')'
      }
      requestUrl += '&' +
        '$select=Datastreams&' +
        '$expand=' +
          'Datastreams(' +
            '$select=unitOfMeasurement%3B' +
            '$expand=' +
              'Sensor($select=name,properties,description),' +
              'ObservedProperty($select=name,properties),' +
              'Observations(' +
                '$select=phenomenonTime,result%3B' +
                '$filter=overlaps(phenomenonTime,' + startTs + '/' + endTs + ');' +
                '$top=100000))'
      // console.log(requestUrl)
      // Request dataset from sta server
      axios.get(this.beluga_proxy + staUrl + encodeURIComponent(requestUrl) + '&nodecode=true')
        .then(response => {
          // console.log(response)
          if (('data' in response) && (typeof response.data === 'object') &&
            ('value' in response.data) && (typeof response.data.value === 'object') &&
            (response.data.value.length >= 1)) {
            const formattedData = this.formatDatasetCast(response.data.value[0])
            if (formattedData !== null) {
              // Add data to dataset
              dataset.data = formattedData
              // Add to data model
              this.$store.commit('add_async_dataset', dataset)
            }
          }
        })
    },
    formatDatasetCast: function (data) {
      // Initialize formatted dataset
      const dataset = {}

      // Process data streams, skip empty streams
      dataset.parameters = []
      data.Datastreams.forEach(ds => {
        if (ds.Observations.length > 0) {
          // Process observations
          const param = {}
          const values = []
          ds.Observations.forEach(obs => {
            const ts = Date.parse(obs.phenomenonTime)
            const val = { ts: ts, value: parseFloat(obs.result) }
            values.push(val)
          })
          param.data = values

          // TODO Integrity checks
          // Process parameter meta data
          // Base information
          param.name = ds.ObservedProperty.name
          param.id = ('properties' in ds.ObservedProperty) ? ds.ObservedProperty.properties.feature_id || 'unknown' : 'unknown'
          // Unit
          param.unit = {
            name: ds.unitOfMeasurement.name,
            symbol: ds.unitOfMeasurement.symbol
          }
          // Sensor
          param.sensor = {
            serial_id: ('properties' in ds.Sensor) ? ds.Sensor.properties.serial_number || 'unknown' : 'unknown',
            name: ds.Sensor.name,
            description: ds.Sensor.description
          }
          // Add parameter to dataset
          dataset.parameters[param.id] = param
        }
      })
      if (Object.keys(dataset.parameters).length > 1) {
        return dataset
      }
      return null
    }
  }
}
